/**
 * Created by senani on 12/19/18.
 */
import React, {Component, Fragment} from "react";
import "./CartBottom.css";
import {Link} from 'react-router-dom';
import {FormattedMessage} from "react-intl";
import CartAllItemsDelete from "../CartItemDelete/CartAllItemsDelete";
import {RESOURCE_BASE_URL,DEVELOPMENT_MODE} from "../../../../configuration";
import axios from "axios";
import InitialQuotationState from "../../QuotationForm/InitialQuotationState";
import NumberFormatter from "../../../Common/NumberFormatter/NumberFormatter";

const CheckoutButton = (props) => {
    if (!DEVELOPMENT_MODE && props.checkedItems.length !== 0 && localStorage.getItem("userRole") !== "ROLE_IMPERSONATE") {

        const goTo = {
            pathname: '/order/confirmation',
            selectedItems: props.checkedItems,
            cartSummary : props.cartSummary
        };

        return (
            <Link to={goTo}>
                <button className="btn btn-default checkout-button">
                    <FormattedMessage id="app.cart.checkout-button"
                                      defaultMessage="Checkout"
                                      description=""/>
                </button>
            </Link>
        )
    } else {
        return (
            <button className="btn btn-default checkout-button" disabled={true}>
                <FormattedMessage id="app.cart.checkout-button"
                                  defaultMessage="Checkout"
                                  description=""/>
            </button>
        )
    }
};

class CartBottom extends Component {

    constructor(props) {
        super(props);
        this.state = {
            cartTotal: 0.0,
            discount : 0.0,
            cartSummary : {...InitialQuotationState.cartSummary}
        }
        ;

        this.getCartSummary = this.getCartSummary.bind(this);
    }

    getCartSummary = () => {
        let resourceUrl = RESOURCE_BASE_URL + 'api/users/' + this.props.userId + '/cart/item/amount/0';
        let axiosConfig = {
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                "Access-Control-Allow-Origin": "*",
            }
        };

        axios.post(resourceUrl, this.props.checkedItems, axiosConfig)
            .then((res) => {

                let summary = {
                    cartTotal : res.data.cartSummary.cartTotal,
                    cartDiscount : res.data.cartSummary.discount.discountAmount
                };

                this.setState({
                    cartSummary: summary
                });
            })
            .catch((err) => {
                console.log("[API] ERROR: ", err);
            });
    };

    componentDidMount() {
        setTimeout(()=>{
            this.getCartSummary();
        }, 1500)
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.userData !== this.props.userData) {
           this.setState({userId: this.props.userId});
        }
        if(prevProps.userId !== this.props.userId){
           this.getCartSummary();
        }
        if(prevProps.itemLength !== this.props.itemLength){
            this.getCartSummary();
        }
    }

    render() {

        let cartDiscount = this.state.cartSummary !== {} ? this.state.cartSummary.cartDiscount:0;
        let cartTotal = this.state.cartSummary !== {} ? this.state.cartSummary.cartTotal:0;

        if(this.props.itemLength === 0){
            cartTotal = 0;
            cartDiscount = 0;
        }

        return (
           <Fragment>
               <div className="container-fluid web-view">
                   <div className="spacer"></div>
                   <div className="row">
                       <label className="cart-summary-lbl"><FormattedMessage id="app.cart.summary"
                                                                             defaultMessage="SUMMARY"
                                                                             description=""/></label>
                   </div>
                   <div className="spacer"></div>

                   <div className="cart-bottom-row">
                       <div className="row">
                           <div className="col-md-8 no-padding">
                                <span className="cart-summary-item-count">
                                <FormattedMessage id="app.cart.item-count"
                                                  defaultMessage="Item Count: "
                                                  description=""/>
                            </span>
                           </div>
                           <div className="col-md-4">
                               <span className="pull-right cart-summary-item-count">{this.props.itemLength}</span>
                           </div>

                       </div>
                       <div className="spacer"></div>

                       <div className="row">
                           <div className="col-md-8 no-padding">
                                <span>
                                <FormattedMessage id="app.cart.discount"
                                                  defaultMessage="Discount: "
                                                  description=""/>
                            </span>
                           </div>
                           <div className="col-md-4">
                               <span className="pull-right">¥ <NumberFormatter num = {cartDiscount}/> </span>
                           </div>


                       </div>
                       <div className="spacer"></div>
                       <div className="row">
                           <div className="col-md-6 no-padding">
                                <span className="cart-total-text">
                                    <FormattedMessage id="app.cart.total"
                                                      defaultMessage="Total: "
                                                      description=""/>
                                </span>&nbsp;
                           </div>
                           <div className="col-md-6">
                               <span className="cart-total-text pull-right"> ¥ <NumberFormatter num = {cartTotal}/></span>
                           </div>
                       </div>
                   </div>
                   {/*<div className="row">
                    <CartAllItemsDelete
                        getCartItems={this.props.getCartItems}
                        userId={this.props.userId}
                    />

                </div>*/}

                   <div className="row">
                       <div className="cart-bottom-row">

                           <div className="row cart-btn-row">
                               <Link to="/quotation/pcb">
                                   <button className="add-new-item-button">
                                       <FormattedMessage id="app.cart.add-new-item-button"
                                                         defaultMessage="Add New Item"
                                                         description=""/>
                                   </button>
                               </Link>



                           </div>
                           <div className="row cart-btn-row">
                               <CheckoutButton
                                   checkedItems={this.props.checkedItems}
                                   itemLength = {this.props.itemLength}
                                   cartSummary = {this.state.cartSummary}
                               />
                           </div>
                       </div>
                   </div>
               </div>
               <div className="row mobile-view cart-summary-fixed">
                   {/*<div className="responsive-summary-content">*/}
                       {/*<p>*/}
                       {/*<b>*/}
                           {/*注文内容*/}
                       {/*</b>*/}
                       {/*</p>*/}

                   {/*</div>*/}
                   <div className="responsive-summary-content">
                       <div className="custom-col-6">
                           商品数
                       </div>
                       <div className="custom-col-6">
                           <span className="pull-right cart-summary-item-count">{this.props.itemLength}</span>
                       </div>
                   </div>
                   <div className="responsive-summary-content">
                       <div className="custom-col-6">
                           値引
                       </div>
                       <div className="custom-col-6">
                           <span className="pull-right">¥ <NumberFormatter num = {cartDiscount}/> </span>
                       </div>
                   </div>
                   <div className="responsive-summary-content">
                       <div className="custom-col-6 cart-total-text-content">
                           注文合計
                       </div>
                       <div className="custom-col-6">

                           <span className="cart-total-text pull-right"> ¥ <NumberFormatter num = {cartTotal}/></span>
                       </div>
                   </div>
                   <hr/>
                   <div className="responsive-summary-content position-cart-bottom-relative">
                       <div className="custom-col-6 position-cart-bottom-absolute-left">
                           <Link to="/pcb_quotation">
                               <button className="btn btn-default add-new-item-button">
                                   <FormattedMessage id="app.cart.add-new-item-button"
                                                     defaultMessage="Add New Item"
                                                     description=""/>
                               </button>
                           </Link>
                       </div>
                       <div className="custom-col-6 position-cart-bottom-absolute-right">
                           <CheckoutButton
                               checkedItems={this.props.checkedItems}
                               itemLength = {this.props.itemLength}
                               cartSummary = {this.state.cartSummary}
                           />
                       </div>

                   </div>

               </div>
           </Fragment>
        )
    }
}

export default CartBottom;



// WEBPACK FOOTER //
// ./src/components/Site/Cart/CartBottom/CartBottom.js